import { ReactNode } from 'react';
import classNames from 'classnames';
import { EnumsType, EnumItemType, EnumValueType } from '..';
import './RadioInput.scss';

interface IRadioInputProps extends React.HtmlHTMLAttributes<HTMLFieldSetElement> {
	name: string;
	value: EnumValueType | EnumValueType[];
	title?: string;
	disabled?: boolean;
	multiple?: boolean;
	items: EnumsType;
	onChangeValue: (
		value: EnumValueType | EnumValueType[],
		name: string,
	) => void;
	isCol?: boolean;
	noUnderLine?: boolean;
	subRender?: () => ReactNode;
}

export const RadioInput: React.FC<IRadioInputProps> = (props) => {
	const {
		title = '',
		isCol = true,
		noUnderLine = false,
		name,
		value,
		onChangeValue,
		subRender,
		multiple = false,
		items,
		disabled = false,
		className,
		...otherProps
	} = props;

	const isChecked = (id: EnumValueType) => {
		return multiple && Array.isArray(value)
			? value.includes(id)
			: value === id;
	};

	const onChangeValueHandler = (id: EnumValueType) => {
		if (multiple && Array.isArray(value)) {
			const newValue = [...value];
			const index = newValue.findIndex((v) => {
				return v === id;
			});
			if (index === -1) {
				newValue.push(id);
			} else {
				newValue.splice(index, 1);
			}
			onChangeValue(newValue, name);
		} else {
			onChangeValue(id, name);
		}
	};

	const renderItem = (item: EnumItemType, i: number) => {
		let itemId: EnumValueType,
			itemTitle = '';
		if (typeof item === 'object') {
			itemId = item.id;
			itemTitle = item.title ? item.title : item.id.toString();
		} else {
			itemId = item;
			itemTitle = item.toString();
		}

		const id = `${name}-item_${itemId}-${i}`;
		const checked = isChecked(itemId);
		return (
			<div key={itemId}>
				<li
					className={classNames('rdc-radio__input', {
						'no-underline': noUnderLine,
					})}
				>
					<input
						type="radio"
						id={id}
						name={id}
						disabled={disabled}
						checked={checked}
						onClick={() => {
							return onChangeValueHandler(itemId);
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								e.preventDefault();
								onChangeValueHandler(itemId);
							}
						}}
						onChange={() => {}}
					/>
					<label htmlFor={id}>{itemTitle}</label>
				</li>
				{checked && subRender && subRender()}
			</div>
		);
	};

	return (
		<fieldset
			className={classNames(
				className,
				'rdc-radio',
				isCol ? 'rcol' : 'rrow',
			)}
			{...otherProps}
			aria-disabled={disabled}
		>
			{!!title && (
				<legend className="headline-xsmall rdc-radio__title">
					{title}
				</legend>
			)}
			<ul className="rdc-radio__list">{items.map(renderItem)}</ul>
		</fieldset>
	);
};
